module.exports = __webpack_public_path__ + "static/media/photo140.3117d0b5.jpg";